import { render } from "./UserSettingsSection.vue?vue&type=template&id=7d085a4e&scoped=true"
import script from "./UserSettingsSection.vue?vue&type=script&lang=js"
export * from "./UserSettingsSection.vue?vue&type=script&lang=js"

import "./UserSettingsSection.vue?vue&type=style&index=0&id=7d085a4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d085a4e"]])

export default __exports__